import { render, staticRenderFns } from "./Documentos.vue?vue&type=template&id=6282055a&scoped=true&"
import script from "./documentos.ts?vue&type=script&lang=ts&"
export * from "./documentos.ts?vue&type=script&lang=ts&"
import style0 from "./Documentos.vue?vue&type=style&index=0&id=6282055a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6282055a",
  null
  
)

export default component.exports